import React, { CSSProperties, PropsWithChildren } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalFooter, HStack, Flex, Text, VStack } from '@chakra-ui/react';
import { svgIconPaths } from '@/assets/svg/icons';
import SvgIcon from '@/components/atoms/SvgIcon';

export type TModalContainerProps = {
  isOpen: boolean;
  title?: string;
  footerContent?: React.ReactNode;
  headerContent?: React.ReactNode;
  onClose?: () => void;
  isCentered?: boolean;
  width?: string;
  height?: string;
  contentStyle?: CSSProperties;
  titleFontSize?: string;
  backgroundColor?: string;
  modalBodyPadding?: string | number;
  titleBottomMargin?: string;
  overflowY?: 'scroll' | 'auto' | 'hidden';
};

const ModalContainer = ({
  isOpen = false,
  children,
  title,
  footerContent,
  headerContent,
  onClose = () => {},
  isCentered = true,
  height,
  contentStyle,
  backgroundColor = '#F8FCFF',
  width = '614px',
  modalBodyPadding = '8px 24px',
  titleBottomMargin = '20px',
  overflowY = 'scroll',
}: PropsWithChildren<TModalContainerProps>) => {
  const isCustomHeader = !!headerContent;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={isCentered}>
      <ModalOverlay>
        <ModalContent
          backgroundColor={backgroundColor}
          minWidth={width}
          minHeight={height}
          maxHeight={'90vh'}
          overflowY={overflowY}
          paddingX={'40px'}
          paddingY={'40px'}
          style={contentStyle}
        >
          {!isCustomHeader && (
            <HStack flex={1} marginBottom={titleBottomMargin} alignItems={'center'}>
              <Flex flex={1} />
              <Flex flex={5} justifyContent={'center'} alignItems={'center'}>
                <Text variant={'loraSmallTitle'} fontWeight={500}>
                  {title}
                </Text>
              </Flex>
              <Flex flex={1} cursor={'pointer'} onClick={onClose} justifyContent={'flex-end'} alignItems={'center'}>
                <VStack
                  _hover={{ backgroundColor: 'background.cloudGray' }}
                  width={'24px'}
                  height={'24px'}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <SvgIcon iconPath={svgIconPaths.close} color={'primary.black'} size={'18'} />
                </VStack>
              </Flex>
            </HStack>
          )}
          {isCustomHeader && headerContent}
          <VStack padding={modalBodyPadding} spacing={4}>
            {children}
          </VStack>
          {footerContent && <ModalFooter>{footerContent}</ModalFooter>}
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
};

export default ModalContainer;
